// extracted by mini-css-extract-plugin
module.exports = {"container":"_2PD3Whhjvf4Hf_MNKN-PJ9"};